import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const devicesApi = createAsyncThunk("devices", async () => {
  const response = await axiosInstance.get("/devices");
  return response.data;
});

const devicesSlice = createSlice({
  name: "devices",
  initialState: {
    devices: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(devicesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(devicesApi.fulfilled, (state, action) => {
        state.devices = action.payload;
        state.loading = false;
      })
      .addCase(devicesApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default devicesSlice.reducer;
